export default {
  MUNICIPIOS: {
    parametroQuery: 'nome',
    tituloX: 'Municípios'
  },
  SITUACAO_PAGAMENTO: {
    parametroQuery: 'status_vtn',
    tituloX: 'Situação de pagamento'
  },
  TIPO_CADASTRO: {
    parametroQuery: 'tipo_cadastro',
    tituloX: 'Tipo de cadastro'
  },
  PERIODO: {
    parametroQuery: 'data_criacao',
    tituloX: {
      day: 'Data de cadastro',
      month: 'Mês de cadastro',
      year: 'Ano de cadastro'
    }
  },
  TIPO: {
    QUANTIDADE: {
      tituloY: 'Quantidade de VTNs',
      switchValue: false,
      tipoQuery: 'count'
    },
    AREA: {
      tituloY: 'Valor final do imóvel (em R$)',
      switchValue: true,
      tipoQuery: 'sum'
    }
  },
  DEFAULT: {
    tipoQuery: 'count',
    parametroQuery: 'nome',
    tituloX: 'Municípios',
    tituloY: 'Quantidade de processos',
    switchValue: false,
    abaAtiva: 'MUNICIPIOS',
    showGrafico: true
  },
  TIPO_DATA: {
    diario: 'day',
    mensal: 'month',
    anual: 'year'
  },
  FILTRO_EMPTY: {
    status: null,
    cpfCnpjInteressado: null,
    nomeRazaoSocialInteressado: null,
    municipios: [],
    periodo: null,
    formaPagamento: null,
    numeroProcesso: null,
    pagina: 0,
    tamanhoPagina: 15,
    simplificado: false,
    ordem: null,
    ordemDirecao: null
  },
  SETORES: {
    TODOS: ['GAT', 'CAF', 'CPAT', 'GP', 'GDA'],
    GERENTE: ['GAT', 'GDA'],
    ANALISTA: ['GAT'],
    COORDENADOR: ['CAF'],
    PRESIDENTE: ['CPAT', 'GP'],
    ADM_S1: ['GP']
  },
  PERFIS: [
    {
      codigo: 'GERENTE',
      nome: 'Gerente'
    },
    {
      codigo: 'ANALISTA',
      nome: 'Analista'
    },
    {
      codigo: 'COORDENADOR',
      nome: 'Coordenador'
    },
    {
      codigo: 'PRESIDENTE',
      nome: 'Presidente'
    },
    {
      codigo: 'ADM_S1',
      nome: 'Administrativo S2'
    }
  ],
  STATUS: [
    {
      id: 'CRIADO',
      nome: 'Criado'
    },
    {
      id: 'AGUARDANDO_VALIDACAO',
      nome: 'Aguardando validação'
    },
    {
      id: 'ATIVO',
      nome: 'Ativo'
    },
    {
      id: 'EM_ATRASO',
      nome: 'Em atraso'
    },
    {
      id: 'DESISTENTE',
      nome: 'Desistente'
    }
  ],
  STATUS_RESUMIDO: [
    {
      id: 'FINALIZADO',
      nome: 'VTNs arrecadados'
    },
    {
      id: 'EM_ANDAMENTO',
      nome: 'VTNs em arrecadação'
    },
    {
      id: 'TODOS',
      nome: 'Todos'
    }
  ],
  TIPOS_PAGAMENTO: [
    {
      id: 'PARCELADO',
      nome: 'Parcelado'
    },
    {
      id: 'A_VISTA',
      nome: 'À vista'
    }
  ],
  TIPOS_PROCESSO: [
    {
      id: 'Oneroso',
      nome: 'Oneroso'
    },
    {
      id: 'Não Oneroso',
      nome: 'Não Oneroso'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/screens/analise/vtn/constants/tipoParametros.js